import { render, staticRenderFns } from "./ConfigAcademicAddEditDialog.vue?vue&type=template&id=e7bdce2a"
import script from "./ConfigAcademicAddEditDialog.vue?vue&type=script&lang=js"
export * from "./ConfigAcademicAddEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports